__turbopack_context__.v({
  "section": "AK1Adq_section",
  "section__content": "AK1Adq_section__content",
  "section__form": "AK1Adq_section__form",
  "section__slider": "AK1Adq_section__slider",
  "section__slider--rotate": "AK1Adq_section__slider--rotate",
  "section__slider-wrp": "AK1Adq_section__slider-wrp",
  "section__video": "AK1Adq_section__video",
});
